export default "__VITE_ASSET__354vIjip__"